import React from "react";
import { useNavigate } from "react-router-dom";
import spongebobCup from "../../assets/spongebob-cup.png";
import surpriseEggs from "../../assets/surprise-eggs.png";
import miniPops from "../../assets/mini-pops.png";
import fruityZone from "../../assets/fruity-zone.png";
import "./BestSellersSection.css";

const BestSellersSection = () => {
  const navigate = useNavigate();

  const handleViewAllClick = () => {
    navigate("/product");
  };

  const handleOrderNowClick = () => {
    navigate("/contact");
  };

  return (
    <>
      <div className="animation-section">
        <div className="semi-circle-animation"></div>
      </div>

      <section className="best-sellers-section">
        <h1>Our Best Sellers</h1>
        <div className="products">
          <div className="product">
            <img src={spongebobCup} alt="Spongebob Collector's Cup" />
            <h2 className="product-title">
              Spongebob Collector's
              <br /> Cup
            </h2>
            <p className="product-description">Playful cups with candies inside</p>

            <div className="product-hover">
              <div className="p-hover-animation">
                <div className="semi-circle-animation"></div>
              </div>
              <h3 className="hover-title">Spongebob Collector's Cup</h3>
              <button className="hover-button" onClick={handleOrderNowClick}>Order Now</button>
            </div>
          </div>
          <div className="product">
            <img src={surpriseEggs} alt="Super Surprise Eggs" />
            <h2 className="product-title">
              Super Surprise
              <br /> Eggs
            </h2>
            <p className="product-description">Chocolate with candy and surprises</p>
            <div className="product-hover">
              <div className="p-hover-animation">
                <div className="semi-circle-animation"></div>
              </div>
              <h3 className="hover-title">Super Surprise Eggs</h3>
              <button className="hover-button" onClick={handleOrderNowClick}>Order Now</button>
            </div>
          </div>
          <div className="product">
            <img src={miniPops} alt="Mini Pops with Toys and Surprise" />
            <h2 className="product-title">
              Mini Pops with Toys and
              <br /> Surprise
            </h2>
            <p className="product-description">It’s not just a lollipop, it’s a Mini Pop</p>
            <div className="product-hover">
              <div className="p-hover-animation">
                <div className="semi-circle-animation"></div>
              </div>
              <h3 className="hover-title">Mini Pops with Toys</h3>
              <button className="hover-button" onClick={handleOrderNowClick}>Order Now</button>
            </div>
          </div>
          <div className="product">
            <img src={fruityZone} alt="Fruity Zone-JOY Surprise Egg" />
            <h2 className="product-title">
              Fruity Zone-JOY Surprise
              <br /> Egg
            </h2>
            <p className="product-description">Joy inside a small pack</p>
            <div className="product-hover">
              <div className="p-hover-animation">
                <div className="semi-circle-animation"></div>
              </div>
              <h3 className="hover-title">Fruity Zone-JOY Surprise Egg</h3>
              <button className="hover-button" onClick={handleOrderNowClick}>Order Now</button>
            </div>
          </div>
        </div>
        <button className="view-all-button" onClick={handleViewAllClick}>View All Products</button>
      </section>
    </>
  );
};

export default BestSellersSection;